import { render, staticRenderFns } from "./browsetable.vue?vue&type=template&id=11e5484c&scoped=true&"
import script from "./browsetable.vue?vue&type=script&lang=js&"
export * from "./browsetable.vue?vue&type=script&lang=js&"
import style0 from "./browsetable.vue?vue&type=style&index=0&id=11e5484c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e5484c",
  null
  
)

export default component.exports